class UpsUsersController {
    static controller($scope) {
        'ngInject';


    }
}

export default UpsUsersController.controller;



// WEBPACK FOOTER //
// ./src/users/forgot-password/no-account.users.controller.js